import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const GET_OBJECT_COUNT = registerQuery({
  fieldName: 'crmObjectsData',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http.post(`crm-search/search`, {
      query: {
        portalId: PortalIdParser.get()
      },
      data: {
        objectTypeId
      }
    });
  }
});